module.exports = __webpack_public_path__ + "static/Icon-78a1d2d318c60939bccfffcb2c523ca1.png";